import React from 'react';

const CATEGORIES = [
  {
    label: 'Backend & APIs',
    icon: (
      <svg className="w-4 h-4" fill="none" stroke="currentColor" strokeWidth={1.5} viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" d="M5.25 14.25h13.5m-13.5 0a3 3 0 01-3-3m3 3a3 3 0 100 6h13.5a3 3 0 100-6m-16.5-3a3 3 0 013-3h13.5a3 3 0 013 3m-19.5 0a4.5 4.5 0 01.9-2.7L5.737 5.1a3.375 3.375 0 012.7-1.35h7.126c1.062 0 2.062.5 2.7 1.35l2.587 3.45a4.5 4.5 0 01.9 2.7m0 0a3 3 0 01-3 3m0 3h.008v.008h-.008v-.008zm0-6h.008v.008h-.008v-.008zm-3 6h.008v.008h-.008v-.008zm0-6h.008v.008h-.008v-.008z" />
      </svg>
    ),
    skills: ['Laravel', 'PHP', 'FastAPI', 'REST APIs', 'Queue Systems', 'WebSockets', 'Laravel Reverb', 'Socket.io'],
  },
  {
    label: 'Frontend & Mobile',
    icon: (
      <svg className="w-4 h-4" fill="none" stroke="currentColor" strokeWidth={1.5} viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" d="M10.5 1.5H8.25A2.25 2.25 0 006 3.75v16.5a2.25 2.25 0 002.25 2.25h7.5A2.25 2.25 0 0018 20.25V3.75a2.25 2.25 0 00-2.25-2.25H13.5m-3 0V3h3V1.5m-3 0h3m-3 18.75h3" />
      </svg>
    ),
    skills: ['React.js', 'Angular', 'Vue.js', 'React Native', 'Livewire', 'Inertia.js', 'TypeScript', 'TailwindCSS'],
  },
  {
    label: 'AI & Automation',
    icon: (
      <svg className="w-4 h-4" fill="none" stroke="currentColor" strokeWidth={1.5} viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" d="M9.813 15.904L9 18.75l-.813-2.846a4.5 4.5 0 00-3.09-3.09L2.25 12l2.846-.813a4.5 4.5 0 003.09-3.09L9 5.25l.813 2.846a4.5 4.5 0 003.09 3.09L15.75 12l-2.846.813a4.5 4.5 0 00-3.09 3.09z" />
      </svg>
    ),
    skills: ['ChatGPT / OpenAI', 'Gemini', 'AI Agents', 'LLM Integration', 'Intelligent Extraction', 'Claude / Claude Code', 'Workflow Automation'],
  },
  {
    label: 'Databases',
    icon: (
      <svg className="w-4 h-4" fill="none" stroke="currentColor" strokeWidth={1.5} viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" d="M20.25 6.375c0 2.278-3.694 4.125-8.25 4.125S3.75 8.653 3.75 6.375m16.5 0c0-2.278-3.694-4.125-8.25-4.125S3.75 4.097 3.75 6.375m16.5 0v11.25c0 2.278-3.694 4.125-8.25 4.125s-8.25-1.847-8.25-4.125V6.375m16.5 2.625c0 2.278-3.694 4.125-8.25 4.125s-8.25-1.847-8.25-4.125" />
      </svg>
    ),
    skills: ['MySQL', 'PostgreSQL', 'MongoDB', 'Firebase', 'Realm'],
  },
  {
    label: 'Infrastructure & DevOps',
    icon: (
      <svg className="w-4 h-4" fill="none" stroke="currentColor" strokeWidth={1.5} viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" d="M2.25 15a4.5 4.5 0 004.5 4.5H18a3.75 3.75 0 001.332-7.257 3 3 0 00-3.758-3.848 5.25 5.25 0 00-10.233 2.33A4.502 4.502 0 002.25 15z" />
      </svg>
    ),
    skills: ['AWS', 'Docker', 'CI/CD', 'Linux', 'Git', 'Digital Ocean', 'WHM / cPanel'],
  },
  {
    label: 'Integrations',
    icon: (
      <svg className="w-4 h-4" fill="none" stroke="currentColor" strokeWidth={1.5} viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" d="M13.19 8.688a4.5 4.5 0 011.242 7.244l-4.5 4.5a4.5 4.5 0 01-6.364-6.364l1.757-1.757m13.35-.622l1.757-1.757a4.5 4.5 0 00-6.364-6.364l-4.5 4.5a4.5 4.5 0 001.242 7.244" />
      </svg>
    ),
    skills: ['Stripe', 'PayPal', 'Twilio', 'Firebase', 'OneSignal', 'Klaviyo', 'WhatsApp Business', 'Mailgun', 'Acuity', 'Zapier', 'Google Maps API'],
  },
];

export default function Skills() {
  return (
    <section id="skills" className="py-16 lg:py-24 bg-slate-950">
      <div className="max-w-6xl mx-auto px-5 sm:px-6">

        <p className="font-mono text-sky-400 text-xs sm:text-sm tracking-widest mb-2">04. Skills</p>
        <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-slate-100 mb-8 lg:mb-14">Tech stack &amp; tools</h2>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-5">
          {CATEGORIES.map(cat => (
            <div
              key={cat.label}
              className="bg-slate-900 border border-slate-800 hover:border-sky-500/30 rounded-xl p-6 transition-all group"
            >
              {/* Category header */}
              <div className="flex items-center gap-3 mb-5">
                <div className="w-8 h-8 rounded-lg bg-sky-500/10 border border-sky-500/20 text-sky-400 flex items-center justify-center group-hover:bg-sky-500 group-hover:text-white group-hover:border-sky-500 transition-all">
                  {cat.icon}
                </div>
                <h3 className="text-slate-200 font-semibold text-sm">{cat.label}</h3>
              </div>

              {/* Skills */}
              <div className="flex flex-wrap gap-2">
                {cat.skills.map(s => (
                  <span
                    key={s}
                    className="font-mono text-xs text-slate-400 hover:text-sky-300 bg-slate-800 hover:bg-sky-400/10 border border-slate-700 hover:border-sky-400/30 px-2.5 py-1 rounded transition-all cursor-default"
                  >
                    {s}
                  </span>
                ))}
              </div>
            </div>
          ))}
        </div>

      </div>
    </section>
  );
}
